<template>
    <div class="regist">
        <form method="post" class="dialog-form">
            <el-input placeholder="用户名" v-model="userName" clearable></el-input>
            <el-input placeholder="密码" v-model="password" show-password></el-input>
            <el-input placeholder="手机号码" v-model="phoneNumber"></el-input>
            <div class="btn-regist">
                <el-button type="primary" @click="registEvent">注 册</el-button>
            </div>
            <div class="notice">
                注册即同意bibite
                <span>服务协议</span>
                和
                <span>隐私条款</span>
            </div>
        </form>
    </div>
</template>

<script>
/* eslint-disable */
import { get, post } from '@/api/index'

export default {
    data() {
        return {
            userName: '',
            password: '',
            phoneNumber: ''
        }
    },
    methods: {
        // 注册
        registEvent() {
            const url = this.$baseUrl +  '/user/register';
            var param = {
                'username': this.userName,
                'password': this.password,
                'telPhone': this.phoneNumber
            };
            post(url, JSON.stringify(param)).then(resp => {
                if (resp.code === 200) {
                    this.$confirm('注册成功! 是否查看新手指引?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$router.push('/guide');
                    }).catch(() => {

                    })
                } else {
                   this.$notify.error({
                        title: "错误",
                        message: resp.info,
                        offset: 100
                    }) 
                }
            }).catch(err => {
                this.$notify.error({
                    title: "错误",
                    message: err,
                    offset: 100
                })
            })
        }
    }
}
</script>

<style lang="scss">
.regist{
    padding: 20px 0;
    .dialog-form{
        width: 60%;
        margin: 0 auto;
        padding: 5px;
        .el-input{
            padding: 5px;
            .el-input__inner{
                background-color: #1e1e1e !important;
                border-color: #1e1e1e !important;
            }
            .el-input__inner:focus{
                color: #fff;
            }
        }
        .btn-regist{
            padding: 5px;
            display: inline-block;
            width: 100%;
            margin-top: 10px;
        }
        .el-button{
            width: 100%;
            background-color: #eb602e;
            border-color: #eb602e;
        }
        .el-button:hover{
            background-color: #8c3c1f;
        }
        .notice{
            color: #807c7c;
            font-size: 12px;
            padding: 5px;
            span{
                color: #4184E1;
            }
        }
    }
}
</style>
